import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UserRole } from '@briq/shared/src/utils/types'

import {
  getInvalidContractDetected,
  getSessionTimeoutDetected,
  getUserRoles,
  isUserLoggedIn
} from '../redux/user/selectors'
import { getCmsLoginUrl, getPublicUrl } from '../redux/config'
import { useLoginUrl } from '../hooks/useLoginUrl'
import { NotificationActions } from '../redux/notifications'
import { SignalR } from '../utils/signalr'

import { RouteOverride } from '.'

export type AuthRouteProps = {
  requiredRole?: UserRole
  component: React.ElementType
  createConfig: RouteOverride['createConfig']
}

export const AuthRoute = ({ component: Component, requiredRole, createConfig, ...rest }: AuthRouteProps) => {
  const dispatch = useDispatch()
  const loggedIn = useSelector(isUserLoggedIn)
  const cmsLoginUrl = useSelector(getCmsLoginUrl)
  const publicUrl = useSelector(getPublicUrl)
  const loginUrl = useLoginUrl()
  const invalidContractDetected = useSelector(getInvalidContractDetected)
  const sessionTimeoutDetected = useSelector(getSessionTimeoutDetected)
  const roles = useSelector(getUserRoles)

  useEffect(() => {
    const isAuthorized = loggedIn && (!requiredRole || roles.includes(requiredRole))
    if (isAuthorized || invalidContractDetected || sessionTimeoutDetected) return

    if (!cmsLoginUrl) return
    location.replace(loggedIn ? publicUrl : loginUrl)
  }, [cmsLoginUrl, invalidContractDetected, loggedIn, loginUrl, publicUrl, requiredRole, roles, sessionTimeoutDetected])

  useEffect(() => {
    if (loggedIn && !SignalR.isConnected()) {
      dispatch(NotificationActions.startSignalR())
    }
  }, [loggedIn, dispatch])

  if (!loggedIn) return null

  return <Component config={createConfig} {...rest} />
}
